RivalIQ.apps.Favorites.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Empty = Marionette.Dashboard.views.ItemView.mixin({
        template: '#favoritesEmptyTemplate',
        className: 'favorites empty',

        mixins: {
            Props: Marionette.Dashboard.mixins.Props
        }
    });

    function checkForDashboards() {
        const dashboard = RivalIQ.state.dashboards.first();

        if (dashboard) {
            return `/dashboards/${dashboard.id}`;
        }
    }

    curations.Empty = RivalIQ.apps.Dashboard.models.Curation.extend({
        beforeFilters: [
            checkForDashboards
        ],
        title: function () {
            return '';
        },
        timePeriod: false,
        companySets: false,
        widgetsView: Empty,
        getWidgets: function () {
            return new Backbone.Collection();
        }
    });
});
